
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#BD0A36","d":"M28 0L0 16.75v33.5L28 67l28-16.75v-33.5L28 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M23.008 31.78h5.26c.78 0 1.551-.062 2.317-.185a6.313 6.313 0 002.046-.676 3.728 3.728 0 001.44-1.413c.362-.614.544-1.413.544-2.396 0-.983-.182-1.782-.543-2.396a3.734 3.734 0 00-1.44-1.413 6.312 6.312 0 00-2.047-.676 14.539 14.539 0 00-2.317-.184h-5.26v9.339zM19 19h10.396c1.892 0 3.45.253 4.676.758 1.224.506 2.191 1.147 2.901 1.925a6.519 6.519 0 011.482 2.62c.278.97.418 1.906.418 2.807 0 .929-.167 1.823-.501 2.683a7.547 7.547 0 01-1.44 2.334 8.196 8.196 0 01-2.297 1.762c-.904.478-1.914.772-3.027.88L40 48h-5.01l-7.515-12.78h-4.467V48H19V19z"}})])])
          )
        }
      }
    